import { CANONICAL_ORIGIN, absoluteUrl } from './shared'

export interface Crumb {
  name: string
  url: string
}

export const breadcrumbListJsonLd = (
  crumbs: Crumb[],
  { origin = CANONICAL_ORIGIN }: { origin?: string } = {},
) => {
  if (crumbs.length < 2) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: absoluteUrl(crumb.url, origin),
    })),
  }
}
